const rem = ["0.25rem","0.5rem", "0.75rem", "1rem", "1.25rem", "1.5rem", "2rem", "2.5rem", "3rem"];
const defaultFontSizes = ["4px","6px","8px", "10px", "12px", "14px", "16px", "18px", "20px", "24px", "28px", "32px"];
export default {
    fontSizes: {
        default: defaultFontSizes,
        rem: rem,
        mixed: [...defaultFontSizes,...rem],
        minimal: ["12px", "14px", "16px", "18px", "20px"]
    },
    // Other editor configurations...
}